// export function bookingEvents() {
// 	const bookingBtn = document.querySelector("#open-booking");
// 	if (!bookingBtn) return;
// 	async function firstClick(e) {
// 		e.preventDefault();
// 		bookingBtn.removeEventListener("click", firstClick);
// 		try {
// 			const { initBooking } = await import("./booking.js");
// 			initBooking(bookingBtn)();
// 		} catch (err) {
// 			console.error("Failed to load booking module:", err);
// 		}
// 	}
// 	bookingBtn.addEventListener("click", firstClick);
// }

export function bookingEvents() {
	const buttons = Array.from(document.querySelectorAll(".open-booking"));
	if (!buttons.length) return;

	async function firstClick(e) {
		e.preventDefault();
		// unbind this one‐time handler from every button
		buttons.forEach((btn) => btn.removeEventListener("click", firstClick));

		try {
			const { initBooking } = await import("./booking.js");
			// initBooking() returns your “initialOpenBooking” fn, which
			// handles injection, init, opening, and binding future clicks.
			const initialOpenBooking = initBooking();
			initialOpenBooking(e);
		} catch (err) {
			console.error("Failed to load module:", err);
		}
	}

	// bind the one‐time loader to each button
	buttons.forEach((btn) => btn.addEventListener("click", firstClick));
}
